<div
    class="agpr-copilotSwitchBanner"
    [class.agpr-copilotSwitchBanner--card]="variant === variantEnum.card"
    [class.expanded]="!isCollapsed"
>
    <agpr-panel
        id="id"
        [(collapsed)]="isCollapsed"
        [contentPadding]="false"
        [paddingBottom]="0"
        [marginTop]="0">
            <ng-template #panelHeader>
                <div class="agpr-copilotSwitchBanner-top">
                    <div class="agpr-copilotSwitchBanner-topHeading">
                        <div class="agpr-copilotSwitchBanner-topIcon">
                            <span class="fa-kit-duotone fa-agpr-ai-generic"></span>
                        </div>
                        <h2 class="agpr-copilotSwitchBanner-topTitle">
                            {{ title | localize}}
                        </h2>
                    </div>

                    @if (isCollapsed) {
                        <ng-container *ngTemplateOutlet="copilotSwitch;"></ng-container>
                    }

                </div>
            </ng-template>

            <div class="agpr-copilotSwitchBanner-bottom">
                <p class="agpr-copilotSwitchBanner-description" [innerHTML]="description | localize"></p>
                <div class="agpr-copilotSwitchBanner-spacer"></div>
                @if (skipCoverageInsights || hasCoverageInsightsEnabled) {
                    <ng-container *ngTemplateOutlet="copilotSwitch;"></ng-container>
                } @else {
                    <div class="agpr-copilotSwitchBanner-button">
                        <agpr-button
                            [id]="`${id}_learnMore`"
                            label="Core.upsellInfoDialog.learnMore"
                            [style]="buttonTypes.primaryB"
                            (click)="learnMore()"
                        ></agpr-button>
                    </div>
                }
            </div>
    </agpr-panel>
</div>

<ng-template #copilotSwitch>
    <div class="agpr-copilotSwitchBanner-switch">
        @let hideSwithLable = variant === variantEnum.card && isCollapsed;
        <agpr-social-switch
            [(ngModel)]="value"
            [onText]="hideSwithLable ? '' : 'Discover.distribution.newAiDistribution.template.openAiToggle'"
            [offText]="hideSwithLable ? '' : 'Discover.distribution.newAiDistribution.template.openAiToggle'"
            [padding]="0"
            [stopPropagation]="true"
            (ngModelChange)="onModelChange(value)">
        </agpr-social-switch>
    </div>
</ng-template>

